import React, { useMemo, useCallback } from 'react';
import ReactApexChart from "react-apexcharts";

const RDSWeeklyChart = ({ days = [], counts = [] }) => {

    const shortenNumber = useCallback((value) => {
        if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
        if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
        if (value >= 1_000) return (value / 1_000).toFixed(1) + "k";
        return value;
    }, []);

    const options = useMemo(() => ({
        chart: {
            type: 'area',
            height: 320,
            toolbar: { show: false }
        },
        dataLabels: {
            enabled: true,
            formatter: shortenNumber
        },
        colors: ['#9367B4'],
        markers: {
            size: 3,
            strokeColor: '#9367B4'
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        grid: {
            borderColor: '#e5e7eb',
            strokeDashArray: 4,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } }
        },
        xaxis: {
            type: 'category',
            categories: days,
            axisTicks: { show: false },
            axisBorder: { show: false }
        },
        yaxis: { show: false },
        legend: { show: false },
        tooltip: {
            theme: "dark",
            y: { formatter: shortenNumber }
        }
    }), [days, shortenNumber]);

    const series = useMemo(() => ([
        {
            name: 'Tokens',
            data: counts
        }
    ]), [counts]);

    return (
        <ReactApexChart
            options={options}
            series={series}
            type="area"
            height={320}
        />
    );
};

export default RDSWeeklyChart;
